import './loader.scss';

// eslint-disable-next-line react/prop-types
const Loader = ({ size }) => {
    return (
        <div className={'a-loader ' + size} data-testid="loader">
            <div className="a-loader__content" />
        </div>
    );
};

export default Loader;
